module.exports = __webpack_public_path__ + "assets/3a507f3d841feaf8072dea8e5941beef.png";